import  { ReactNode } from "react";

import "./form-wrapper.scss"

interface FormWrapperProps {
  className?: string;
  children: ReactNode;
}

/**
 * FormWrapper is a reusable container component.
 *
 * @param {string} className - Optional additional class names to apply.
 * @param {ReactNode} children - The content to render inside the wrapper.
 */
export const FormWrapper = ({ className, children }: FormWrapperProps) => {
  return <div className={"form-wrapper " + className}>{children}</div>;
};
